export default {
  REQUIRED: "required",
  DISABLED: "disabled",
  OPTIONAL: "optional",
};
